/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AuditActivityResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { PagedAuditRequestResponse } from '../models';
/**
 * AuditApi - axios parameter creator
 * @export
 */
export const AuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The catalogue of activities an audit request can be stamped with, sorted by label. Feeds the activity filter dropdown; pass an entry\'s `key` as the `activity` query parameter on `GET /api/v1/audit/requests`.
         * @summary List the audit activity catalogue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditActivitiesV1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/audit/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of Audit events. All supplied filters are ANDed.  Free-text search (`q`) is date-bounded: when `q` is supplied without `from`, the search window defaults to the most recent 30 days; the maximum `from`→`to` span for a `q` search is 90 days (400 beyond that). The effective window is echoed in `searchWindowFrom` / `searchWindowTo`, which are null when no `q` was supplied.  Masked values (secrets, `customer.email`, card data) are stored masked, so searching for their cleartext never matches. 
         * @summary List audit requests
         * @param {string} [path] 
         * @param {string} [userId] 
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {string} [sort] Sort field — one of createdAt, path, httpResponseCode, method (400 otherwise).
         * @param {GetAuditListV1DirectionEnum} [direction] 
         * @param {string} [partnerId] Filter by partner ULID
         * @param {string} [merchantId] Filter by merchant ULID
         * @param {string} [apiKeyId] Filter by API key ULID
         * @param {GetAuditListV1UserTypeEnum} [userType] Filter by user type
         * @param {string} [from] Inclusive lower bound on createdAt (ISO 8601 date, interpreted as UTC start of day).
         * @param {string} [to] Inclusive upper bound on createdAt (ISO 8601 date, interpreted as UTC end of day).
         * @param {string} [q] Case-insensitive substring matched against path, query parameters, and the captured (masked) request body. Date-bounded — see the operation description.
         * @param {GetAuditListV1MethodEnum} [method] Filter by HTTP method.
         * @param {number} [status] Filter by exact HTTP response code. Mutually exclusive with &#x60;statusClass&#x60;.
         * @param {GetAuditListV1StatusClassEnum} [statusClass] Filter by response status class — SUCCESS (2xx), CLIENT_ERROR (4xx), SERVER_ERROR (5xx). Mutually exclusive with &#x60;status&#x60;.
         * @param {string} [activity] Filter by activity key, as returned by &#x60;GET /api/v1/audit/activities&#x60;. An unrecognised key is rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditListV1: async (path?: string, userId?: string, page?: number, size?: number, sort?: string, direction?: GetAuditListV1DirectionEnum, partnerId?: string, merchantId?: string, apiKeyId?: string, userType?: GetAuditListV1UserTypeEnum, from?: string, to?: string, q?: string, method?: GetAuditListV1MethodEnum, status?: number, statusClass?: GetAuditListV1StatusClassEnum, activity?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/audit/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (apiKeyId !== undefined) {
                localVarQueryParameter['apiKeyId'] = apiKeyId;
            }

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (method !== undefined) {
                localVarQueryParameter['method'] = method;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (statusClass !== undefined) {
                localVarQueryParameter['statusClass'] = statusClass;
            }

            if (activity !== undefined) {
                localVarQueryParameter['activity'] = activity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditApi - functional programming interface
 * @export
 */
export const AuditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditApiAxiosParamCreator(configuration)
    return {
        /**
         * The catalogue of activities an audit request can be stamped with, sorted by label. Feeds the activity filter dropdown; pass an entry\'s `key` as the `activity` query parameter on `GET /api/v1/audit/requests`.
         * @summary List the audit activity catalogue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditActivitiesV1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditActivityResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditActivitiesV1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditApi.getAuditActivitiesV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of Audit events. All supplied filters are ANDed.  Free-text search (`q`) is date-bounded: when `q` is supplied without `from`, the search window defaults to the most recent 30 days; the maximum `from`→`to` span for a `q` search is 90 days (400 beyond that). The effective window is echoed in `searchWindowFrom` / `searchWindowTo`, which are null when no `q` was supplied.  Masked values (secrets, `customer.email`, card data) are stored masked, so searching for their cleartext never matches. 
         * @summary List audit requests
         * @param {string} [path] 
         * @param {string} [userId] 
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {string} [sort] Sort field — one of createdAt, path, httpResponseCode, method (400 otherwise).
         * @param {GetAuditListV1DirectionEnum} [direction] 
         * @param {string} [partnerId] Filter by partner ULID
         * @param {string} [merchantId] Filter by merchant ULID
         * @param {string} [apiKeyId] Filter by API key ULID
         * @param {GetAuditListV1UserTypeEnum} [userType] Filter by user type
         * @param {string} [from] Inclusive lower bound on createdAt (ISO 8601 date, interpreted as UTC start of day).
         * @param {string} [to] Inclusive upper bound on createdAt (ISO 8601 date, interpreted as UTC end of day).
         * @param {string} [q] Case-insensitive substring matched against path, query parameters, and the captured (masked) request body. Date-bounded — see the operation description.
         * @param {GetAuditListV1MethodEnum} [method] Filter by HTTP method.
         * @param {number} [status] Filter by exact HTTP response code. Mutually exclusive with &#x60;statusClass&#x60;.
         * @param {GetAuditListV1StatusClassEnum} [statusClass] Filter by response status class — SUCCESS (2xx), CLIENT_ERROR (4xx), SERVER_ERROR (5xx). Mutually exclusive with &#x60;status&#x60;.
         * @param {string} [activity] Filter by activity key, as returned by &#x60;GET /api/v1/audit/activities&#x60;. An unrecognised key is rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditListV1(path?: string, userId?: string, page?: number, size?: number, sort?: string, direction?: GetAuditListV1DirectionEnum, partnerId?: string, merchantId?: string, apiKeyId?: string, userType?: GetAuditListV1UserTypeEnum, from?: string, to?: string, q?: string, method?: GetAuditListV1MethodEnum, status?: number, statusClass?: GetAuditListV1StatusClassEnum, activity?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAuditRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditListV1(path, userId, page, size, sort, direction, partnerId, merchantId, apiKeyId, userType, from, to, q, method, status, statusClass, activity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditApi.getAuditListV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditApi - factory interface
 * @export
 */
export const AuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditApiFp(configuration)
    return {
        /**
         * The catalogue of activities an audit request can be stamped with, sorted by label. Feeds the activity filter dropdown; pass an entry\'s `key` as the `activity` query parameter on `GET /api/v1/audit/requests`.
         * @summary List the audit activity catalogue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditActivitiesV1(options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditActivityResponse>> {
            return localVarFp.getAuditActivitiesV1(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of Audit events. All supplied filters are ANDed.  Free-text search (`q`) is date-bounded: when `q` is supplied without `from`, the search window defaults to the most recent 30 days; the maximum `from`→`to` span for a `q` search is 90 days (400 beyond that). The effective window is echoed in `searchWindowFrom` / `searchWindowTo`, which are null when no `q` was supplied.  Masked values (secrets, `customer.email`, card data) are stored masked, so searching for their cleartext never matches. 
         * @summary List audit requests
         * @param {string} [path] 
         * @param {string} [userId] 
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {string} [sort] Sort field — one of createdAt, path, httpResponseCode, method (400 otherwise).
         * @param {GetAuditListV1DirectionEnum} [direction] 
         * @param {string} [partnerId] Filter by partner ULID
         * @param {string} [merchantId] Filter by merchant ULID
         * @param {string} [apiKeyId] Filter by API key ULID
         * @param {GetAuditListV1UserTypeEnum} [userType] Filter by user type
         * @param {string} [from] Inclusive lower bound on createdAt (ISO 8601 date, interpreted as UTC start of day).
         * @param {string} [to] Inclusive upper bound on createdAt (ISO 8601 date, interpreted as UTC end of day).
         * @param {string} [q] Case-insensitive substring matched against path, query parameters, and the captured (masked) request body. Date-bounded — see the operation description.
         * @param {GetAuditListV1MethodEnum} [method] Filter by HTTP method.
         * @param {number} [status] Filter by exact HTTP response code. Mutually exclusive with &#x60;statusClass&#x60;.
         * @param {GetAuditListV1StatusClassEnum} [statusClass] Filter by response status class — SUCCESS (2xx), CLIENT_ERROR (4xx), SERVER_ERROR (5xx). Mutually exclusive with &#x60;status&#x60;.
         * @param {string} [activity] Filter by activity key, as returned by &#x60;GET /api/v1/audit/activities&#x60;. An unrecognised key is rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditListV1(path?: string, userId?: string, page?: number, size?: number, sort?: string, direction?: GetAuditListV1DirectionEnum, partnerId?: string, merchantId?: string, apiKeyId?: string, userType?: GetAuditListV1UserTypeEnum, from?: string, to?: string, q?: string, method?: GetAuditListV1MethodEnum, status?: number, statusClass?: GetAuditListV1StatusClassEnum, activity?: string, options?: RawAxiosRequestConfig): AxiosPromise<PagedAuditRequestResponse> {
            return localVarFp.getAuditListV1(path, userId, page, size, sort, direction, partnerId, merchantId, apiKeyId, userType, from, to, q, method, status, statusClass, activity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditApi - object-oriented interface
 * @export
 * @class AuditApi
 * @extends {BaseAPI}
 */
export class AuditApi extends BaseAPI {
    /**
     * The catalogue of activities an audit request can be stamped with, sorted by label. Feeds the activity filter dropdown; pass an entry\'s `key` as the `activity` query parameter on `GET /api/v1/audit/requests`.
     * @summary List the audit activity catalogue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApi
     */
    public getAuditActivitiesV1(options?: RawAxiosRequestConfig) {
        return AuditApiFp(this.configuration).getAuditActivitiesV1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of Audit events. All supplied filters are ANDed.  Free-text search (`q`) is date-bounded: when `q` is supplied without `from`, the search window defaults to the most recent 30 days; the maximum `from`→`to` span for a `q` search is 90 days (400 beyond that). The effective window is echoed in `searchWindowFrom` / `searchWindowTo`, which are null when no `q` was supplied.  Masked values (secrets, `customer.email`, card data) are stored masked, so searching for their cleartext never matches. 
     * @summary List audit requests
     * @param {string} [path] 
     * @param {string} [userId] 
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {string} [sort] Sort field — one of createdAt, path, httpResponseCode, method (400 otherwise).
     * @param {GetAuditListV1DirectionEnum} [direction] 
     * @param {string} [partnerId] Filter by partner ULID
     * @param {string} [merchantId] Filter by merchant ULID
     * @param {string} [apiKeyId] Filter by API key ULID
     * @param {GetAuditListV1UserTypeEnum} [userType] Filter by user type
     * @param {string} [from] Inclusive lower bound on createdAt (ISO 8601 date, interpreted as UTC start of day).
     * @param {string} [to] Inclusive upper bound on createdAt (ISO 8601 date, interpreted as UTC end of day).
     * @param {string} [q] Case-insensitive substring matched against path, query parameters, and the captured (masked) request body. Date-bounded — see the operation description.
     * @param {GetAuditListV1MethodEnum} [method] Filter by HTTP method.
     * @param {number} [status] Filter by exact HTTP response code. Mutually exclusive with &#x60;statusClass&#x60;.
     * @param {GetAuditListV1StatusClassEnum} [statusClass] Filter by response status class — SUCCESS (2xx), CLIENT_ERROR (4xx), SERVER_ERROR (5xx). Mutually exclusive with &#x60;status&#x60;.
     * @param {string} [activity] Filter by activity key, as returned by &#x60;GET /api/v1/audit/activities&#x60;. An unrecognised key is rejected.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApi
     */
    public getAuditListV1(path?: string, userId?: string, page?: number, size?: number, sort?: string, direction?: GetAuditListV1DirectionEnum, partnerId?: string, merchantId?: string, apiKeyId?: string, userType?: GetAuditListV1UserTypeEnum, from?: string, to?: string, q?: string, method?: GetAuditListV1MethodEnum, status?: number, statusClass?: GetAuditListV1StatusClassEnum, activity?: string, options?: RawAxiosRequestConfig) {
        return AuditApiFp(this.configuration).getAuditListV1(path, userId, page, size, sort, direction, partnerId, merchantId, apiKeyId, userType, from, to, q, method, status, statusClass, activity, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAuditListV1DirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetAuditListV1DirectionEnum = typeof GetAuditListV1DirectionEnum[keyof typeof GetAuditListV1DirectionEnum];
/**
 * @export
 */
export const GetAuditListV1UserTypeEnum = {
    AdminUser: 'ADMIN_USER',
    ApiKey: 'API_KEY'
} as const;
export type GetAuditListV1UserTypeEnum = typeof GetAuditListV1UserTypeEnum[keyof typeof GetAuditListV1UserTypeEnum];
/**
 * @export
 */
export const GetAuditListV1MethodEnum = {
    Get: 'GET',
    Post: 'POST',
    Put: 'PUT',
    Patch: 'PATCH',
    Delete: 'DELETE'
} as const;
export type GetAuditListV1MethodEnum = typeof GetAuditListV1MethodEnum[keyof typeof GetAuditListV1MethodEnum];
/**
 * @export
 */
export const GetAuditListV1StatusClassEnum = {
    Success: 'SUCCESS',
    ClientError: 'CLIENT_ERROR',
    ServerError: 'SERVER_ERROR'
} as const;
export type GetAuditListV1StatusClassEnum = typeof GetAuditListV1StatusClassEnum[keyof typeof GetAuditListV1StatusClassEnum];
